import { Box } from "@material-ui/core"
import { Alert } from "@material-ui/lab"
import { ReactElement, useState } from "react"
import { connect } from "react-redux"
import { AppThunkDispatch, metadataUploadTopographicData } from "../../../redux"
import type { UploadFileAction } from "../../../redux/upload/upload.types"
import { UploadFileField } from "../../atoms"
import { DialogWindow, DialogWindowFooter, DialogWindowHeader } from "../../molecules"

import "./upload-topo-data-dialog.styles.scss"
import { useTranslation } from "react-i18next"

export interface IUploadTopograpyDataDialogProps {
  open: boolean
  onClose: () => void
}

export interface IUploadTopograpyDataDialogStateProps {
  upload: (file: File) => void
}

function UploadTopographyDataDialogView(
  props: IUploadTopograpyDataDialogProps & IUploadTopograpyDataDialogStateProps
): ReactElement {
  const { open, onClose, upload } = props
  const [file, setFile] = useState<File | null>(null)
  const { t } = useTranslation("contentManager")

  function onConfirm(): void {
    if (file) upload(file)
    handleClose()
  }

  function handleClose(): void {
    setFile(null)
    onClose()
  }

  function handleFileSelect(file: File): void {
    setFile(file)
  }

  return (
    <DialogWindow open={open}>
      <DialogWindowHeader title={t("uploadTopography.dialog.header")} onClose={onClose} />
      <Box className="upload-topographic-data-dialog">
        <Alert severity="warning">{t("uploadTopography.dialog.header")}</Alert>
        <UploadFileField onSelect={handleFileSelect} accept=".xls, .xlsx" file={file} />
      </Box>
      <DialogWindowFooter onCancel={handleClose} onConfirm={onConfirm} confirmText="Verzend" />
    </DialogWindow>
  )
}

function mapDispatchToProps(dispatch: AppThunkDispatch<UploadFileAction>) {
  return {
    upload: (file: File) => dispatch(metadataUploadTopographicData(file))
  }
}

export const UploadTopographyDataDialog = connect(undefined, mapDispatchToProps)(UploadTopographyDataDialogView)
